import { Field, TextOutput } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection, PageSection } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import React from 'react';
import { PortionSievingDetailsSection, PortionSievingEquipmentSection, PortionSievingRecordGridSection } from '.';

// This section is copied from the ASTM C136 worksheet
let PortionSievingPageSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector, namePrefix }) => {
  const isWholePortion = namePrefix!.endsWith('WholePortion');
  const isCoarsestSievingPortion = namePrefix!.endsWith('WholePortion.Separation.CoarsePortion');
  const isFineSievingPortion = namePrefix!.endsWith('FinePortion.Subspecimen');
  const isIntermediatePortion = !isCoarsestSievingPortion && namePrefix!.endsWith('CoarsePortion');

  // Portion number for intermediate portions. Since we only use it for intermediate portions, and
  // we support a maxmimum of 2 separations, the only case that we actually end up using it for is
  // the coarse portion of the second separation, and we expect the value to be 2 for this case.
  const intermediatePortionNumber = isIntermediatePortion ? namePrefix?.match(/\.Separation\./g)?.length ?? 0 : 0;

  const heading = isWholePortion
    ? 'Portion Sieving'
    : isCoarsestSievingPortion
    ? 'Coarse Portion Sieving'
    : isFineSievingPortion
    ? 'Fine Portion Sieving'
    : `Portion ${intermediatePortionNumber} Sieving`;

  const isCoarsePortionOfSeparationDuringSieving = isCoarsestSievingPortion || isIntermediatePortion;

  return (
    <PageSection heading={heading}>
      <PortionSievingDetailsSection />
      <NamePrefixModifier appendNamePrefix="Sieving">
        <PortionSievingEquipmentSection />
        <PortionSievingRecordGridSection
          isCoarsePortionOfSeparationDuringSieving={isCoarsePortionOfSeparationDuringSieving}
        />
        {isCoarsePortionOfSeparationDuringSieving && (
          <ListFieldSection>
            <Field input={<TextOutput />} name="ExpectedIndividualPanMassRetained" />
          </ListFieldSection>
        )}
      </NamePrefixModifier>
    </PageSection>
  );
};

PortionSievingPageSection = withInjectedProps(PortionSievingPageSection);

export { PortionSievingPageSection };
export default PortionSievingPageSection;
